import { useState } from 'react';

import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';

import { useAppLaunch } from 'contexts/AppLaunch';
import { NextSeo } from 'next-seo';
export default function AboutUs() {
  const { notifications, contentCounts } = useAppLaunch();

  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  return (
    <div>
      <NextSeo
        title="關於我們 | 最真實化妝護膚品評價平台 | Sorra"
        description="Sorra是一個最真實的化妝護膚品評價平台。我們提供化妝品推薦及護膚品推薦，探索用戶對於好用的美妝護膚產品的真實評價。立即訪問Sorra平台，找到適合您的化妝品和護膚品！"
      />

      <main>
        <Menubar props={{ homeExtend: false, sourceUI: 'About' }} />

        <div
          className={
            'globals-centerContentsMargin relative' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
        >
          <MaxWidthContainer className="px-4 pb-[48px] pt-[32px] lg:pb-[128px] lg:pt-[96px]">
            <div className="hidden lg:flex">
              <div className="flex grow items-center justify-center">
                <div className="pr-[64px]">
                  <div className="text-base font-medium text-sorra-gray-800">
                    關於我們
                  </div>
                  <div className="mt-[42px] text-2xl font-medium text-sorra-gray-800">
                    Sorra到底在搞什麼？
                  </div>
                  <div className="mt-[16px] text-5xl font-bold leading-[150%] text-sorra-gray-900">
                    「我們想把真誠、深度、價值注入美妝界！」
                  </div>
                  <div className="mt-[32px] text-xl font-normal text-sorra-gray-900">
                    打開社交媒體，美妝護膚品每天上新、廣告講得越來越吸引、產品評論越來越誇張、行業寫手越來越進取，家裡堆積越來越多不適合自己的產品。
                    <br />
                    <br />
                    而比較美妝品牌、分辨評價、尋找適合自己肌膚的產品，讓人疲累不堪
                    …
                  </div>
                </div>
              </div>
              <div className="contents w-[787px] items-center justify-center">
                <img src="/images/about-hero.png" className="w-[787px]"></img>
              </div>
            </div>

            <div className="block lg:hidden">
              <div className="text-center text-base font-normal text-sorra-gray-800">
                關於我們
              </div>
              <div className="mt-[10px] text-center text-2xl font-normal text-sorra-gray-900">
                Sorra到底在搞什麼？
              </div>
              <div className="mt-[16px] text-center text-3xl font-bold text-sorra-gray-900">
                「我們想把真誠、深度、價值注入美妝界！」
              </div>
              <div className="my-[24px] flex items-center justify-end">
                <img src="/images/about-hero.png" className=""></img>
              </div>
              <div className="mt-[24px] text-base font-normal text-sorra-gray-900">
                打開社交媒體，美妝護膚品每天上新、廣告講得越來越吸引、產品評論越來越誇張、行業寫手越來越進取，家裡堆積越來越多不適合自己的產品。
                <br />
                <br />
                而比較美妝品牌、分辨評價、尋找適合自己肌膚的產品，讓人疲累不堪 …
              </div>
            </div>
          </MaxWidthContainer>

          <div className="bg-[#FFF6F7] pb-[36px] pt-[36px] lg:pb-[96px] lg:pt-[96px]">
            <MaxWidthContainer className="px-4">
              <div className="flex items-center justify-center">
                <div className="max-w-[768px]">
                  <div className="text-center text-2xl font-bold leading-[150%] text-sorra-gray-900 lg:text-5xl">
                    最真實的美妝比較平台
                  </div>
                  <div className="mt-[24px] text-center text-base font-normal text-sorra-gray-900 lg:mt-[32px] lg:text-xl">
                    Sorra與十數萬IG社群讀者互動，收集真正的素人用家意見，Sorra
                    團隊從海量評價中與專家評審進行整理、分析、比對，把最有用、最真實的產品資訊呈現給大眾。
                    <br />
                    <br />
                    不論護膚新手、資深專家都可在Sorra做到最真摯的美妝交流，
                    <br />
                    讓每個選擇更具深度與溫度。
                  </div>
                  <div className="mt-[32px] hidden text-center text-base font-normal text-sorra-gray-900 lg:mt-[48px] lg:block lg:text-xl">
                    直至現時為止，我們已經收集到...
                  </div>
                  <div className="mt-[34px]">
                    <div
                      className="m-auto flex space-x-[10px]"
                      style={{ width: 'max-content' }}
                    >
                      <div className="w-[100px] space-y-[4px] lg:w-[242px] lg:space-y-[8px]">
                        <div className="text-center text-2xl font-bold text-sorra-gray-900 lg:text-5xl">
                          {contentCounts.product_count || 0}
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-2xl">
                          產品數量
                        </div>
                      </div>
                      <div className="w-[100px] space-y-[4px] lg:w-[242px] lg:space-y-[8px]">
                        <div className="text-center text-2xl font-bold text-sorra-gray-900 lg:text-5xl">
                          {contentCounts.review_count || 0}
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-2xl">
                          真實讀者評價
                        </div>
                      </div>
                      <div className="w-[100px] space-y-[4px] lg:w-[242px] lg:space-y-[8px]">
                        <div className="text-center text-2xl font-bold text-sorra-gray-900 lg:text-5xl">
                          {contentCounts.category_count || 0}
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-2xl">
                          產品類別
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MaxWidthContainer>
          </div>

          <MaxWidthContainer className="px-4 pb-[0px] pt-[24px] lg:pb-[96px] lg:pt-[96px]">
            <div className="hidden lg:flex">
              <div className="flex grow items-center justify-center pr-[32px]">
                <div className="">
                  <div className="text-5xl font-bold leading-[150%] text-sorra-gray-900">
                    以真實用家為重心
                  </div>
                  <div className="mt-[32px] text-xl font-normal text-sorra-gray-900">
                    網絡資訊氾濫、廣告誇大其詞、打手四處埋伏 ...
                    <br />
                    <br />
                    Sorra 深信來自大眾、素人、真實用家的評價往往最值得信賴，
                    <br />
                    無刪減的評價外，同時提供好評／差評比例以供參考。
                  </div>
                </div>
              </div>
              <div className="contents w-[600px]">
                <img
                  src="/images/about-content-00.png"
                  className="w-[600px]"
                ></img>
              </div>
            </div>

            <div className="block lg:hidden">
              <div className="text-2xl font-bold leading-[150%] text-sorra-gray-900">
                以真實用家為重心
              </div>
              <div className="mt-[24px] flex w-full items-center justify-center">
                <img src="/images/about-content-00.png" className=""></img>
              </div>
              <div className="mt-[16px] text-base font-normal text-sorra-gray-900">
                網絡資訊氾濫、廣告誇大其詞、打手四處埋伏 ...
                <br />
                <br />
                Sorra 深信來自大眾、素人、真實用家的評價往往最值得信賴，
                <br />
                無刪減的評價外，同時提供好評／差評比例以供參考。
              </div>
            </div>
          </MaxWidthContainer>

          <MaxWidthContainer className="px-4 pb-[0px] pt-[24px] lg:pb-[96px] lg:pt-[96px]">
            <div className="hidden lg:flex">
              <div className="contents w-[600px]">
                <img
                  src="/images/about-content-01.png"
                  className="w-[600px]"
                ></img>
              </div>
              <div className="flex grow items-center justify-center pr-[32px]">
                <div className="">
                  <div className="text-5xl font-bold leading-[150%] text-sorra-gray-900">
                    成份分析：
                    <br />
                    安全性、用途一覽無遺
                  </div>
                  <div className="mt-[32px] text-xl font-normal text-sorra-gray-900">
                    對於用在妳皮膚的美妝成份，妳有權知道更多－－ Sorra
                    團隊與專家評審為妳把關：所有美妝產品成份按含量逐一分析用途與安全性，助妳作出最安心的選擇。
                  </div>
                </div>
              </div>
            </div>

            <div className="block lg:hidden">
              <div className="text-2xl font-bold leading-[150%] text-sorra-gray-900">
                成份分析：
                <br />
                安全性、用途一覽無遺
              </div>
              <div className="mt-[24px] flex w-full items-center justify-center">
                <img src="/images/about-content-01.png" className=""></img>
              </div>
              <div className="mt-[16px] text-base font-normal text-sorra-gray-900">
                對於用在妳皮膚的美妝成份，妳有權知道更多－－ Sorra
                團隊與專家評審為妳把關：所有美妝產品成份按含量逐一分析用途與安全性，助妳作出最安心的選擇。
              </div>
            </div>
          </MaxWidthContainer>

          <MaxWidthContainer className="px-4 pb-[0px] pt-[24px] lg:pb-[96px] lg:pt-[96px]">
            <div className="hidden lg:flex">
              <div className="flex grow items-center justify-center pr-[32px]">
                <div className="">
                  <div className="text-5xl font-bold leading-[150%] text-sorra-gray-900">
                    膚質配對：
                    <br />
                    挑選最適合妳膚質的產品
                  </div>
                  <div className="mt-[32px] text-xl font-normal text-sorra-gray-900">
                    挑選護膚產品應該更加科學、更個人化！
                    根據成份安全性、讀者評價、妳的肌膚狀態以及個人偏好， Sorra
                    與專家評審為妳貼心配對合適品牌、產品建議、成份地雷等，
                    並在平台上提供個人化搜尋設定。
                  </div>
                </div>
              </div>
              <div className="contents w-[600px]">
                <img
                  src="/images/about-content-02.png"
                  className="w-[600px]"
                ></img>
              </div>
            </div>

            <div className="block lg:hidden">
              <div className="text-2xl font-bold leading-[150%] text-sorra-gray-900">
                膚質配對：
                <br />
                挑選最適合妳膚質的產品
              </div>
              <div className="mt-[24px] flex w-full items-center justify-center">
                <img src="/images/about-content-02.png" className=""></img>
              </div>
              <div className="mt-[16px] text-base font-normal text-sorra-gray-900">
                挑選護膚產品應該更加科學、更個人化！
                根據成份安全性、讀者評價、妳的肌膚狀態以及個人偏好， Sorra
                與專家評審為妳貼心配對合適品牌、產品建議、成份地雷等，
                並在平台上提供個人化搜尋設定。
              </div>
            </div>
          </MaxWidthContainer>

          <MaxWidthContainer className="px-4 pb-[0px] pt-[24px] lg:pb-[96px] lg:pt-[96px]">
            <div className="hidden lg:flex">
              <div className="contents w-[600px]">
                <img
                  src="/images/about-content-03.png"
                  className="w-[600px]"
                ></img>
              </div>
              <div className="flex grow items-center justify-center pr-[32px]">
                <div className="">
                  <div className="text-5xl font-bold leading-[150%] text-sorra-gray-900">
                    票選排名：
                    <br />
                    看看素人怎麼選
                  </div>
                  <div className="mt-[32px] text-xl font-normal text-sorra-gray-900">
                    林林總總的產品，不知道哪一個才適合自己？
                    <br />看 Sorra
                    數十萬素人的票選排行就對了！從美妝保養到沐浴護髮，Sorra
                    為市面產品進行評價驗證與分類，根據真實用家好評數做出產品排行榜，並實時更新，讓妳有更全面的參考。
                  </div>
                </div>
              </div>
            </div>

            <div className="block lg:hidden">
              <div className="text-2xl font-bold leading-[150%] text-sorra-gray-900">
                票選排名：
                <br />
                看看素人怎麼選
              </div>
              <div className="mt-[24px] flex w-full items-center justify-center">
                <img src="/images/about-content-03.png" className=""></img>
              </div>
              <div className="mt-[16px] text-base font-normal text-sorra-gray-900">
                林林總總的產品，不知道哪一個才適合自己？
                <br />看 Sorra
                數十萬素人的票選排行就對了！從美妝保養到沐浴護髮，Sorra
                為市面產品進行評價驗證與分類，根據真實用家好評數做出產品排行榜，並實時更新，讓妳有更全面的參考。
              </div>
            </div>
          </MaxWidthContainer>

          <MaxWidthContainer className="px-4 pb-[0px] pt-[24px] lg:pb-[96px] lg:pt-[96px]">
            <div className="hidden lg:flex">
              <div className="flex grow items-center justify-center pr-[32px]">
                <div className="">
                  <div className="text-5xl font-bold leading-[150%] text-sorra-gray-900">
                    積分好禮：
                    <br />
                    讓妳的美妝體驗更具價值
                  </div>
                  <div className="mt-[32px] text-xl font-normal text-sorra-gray-900">
                    每次妳上載新產品體驗或為產品評分，不但能為一眾素人帶來更深度資訊，
                    <br />
                    更會為妳換來新的美妝好物體驗！
                    <br />
                    <br />
                    在 Sorra 上載體驗、評分都可賺取積分，
                    <br />每 ✦$1 Sorra 積分直接兑換 HK$1 在 Sorra
                    上換領各大品牌美妝產品。
                  </div>
                </div>
              </div>
              <div className="contents w-[600px]">
                <img
                  src="/images/about-content-04.png"
                  className="w-[600px]"
                ></img>
              </div>
            </div>

            <div className="block lg:hidden">
              <div className="text-2xl font-bold leading-[150%] text-sorra-gray-900">
                積分好禮：
                <br />
                讓妳的美妝體驗更具價值
              </div>
              <div className="mt-[24px] flex w-full items-center justify-center">
                <img src="/images/about-content-04.png" className=""></img>
              </div>
              <div className="mt-[16px] text-base font-normal text-sorra-gray-900">
                每次妳上載新產品體驗或為產品評分，不但能為一眾素人帶來更深度資訊，
                <br />
                更會為妳換來新的美妝好物體驗！
                <br />
                <br />
                在 Sorra 上載體驗、評分都可賺取積分，
                <br />每 ✦$1 Sorra 積分直接兑換 HK$1 在 Sorra
                上換領各大品牌美妝產品。
              </div>
            </div>
          </MaxWidthContainer>

          <MaxWidthContainer className="px-4 pb-[40px] pt-[40px] lg:pb-[96px] lg:pt-[80px]">
            <div className="flex items-center justify-center">
              <div>
                <div className="text-center text-2xl font-bold leading-[150%] text-sorra-gray-900 lg:text-5xl">
                  Sorra 比比比 買美妝不再中伏！
                </div>
                <div className="mt-[24px] text-center text-base font-normal text-sorra-gray-900 lg:mt-[32px] lg:text-xl">
                  比評價｜比成份｜比膚質
                  <br />
                  最真實的美妝比較平台
                </div>
                <div className="mt-[32px] text-center text-xl font-normal text-sorra-gray-900">
                  <button
                    className="h-[48px] w-full rounded-[8px] bg-sorra-pink text-base font-medium text-[#fff] lg:w-[300px]"
                    onClick={() => {
                      window.location.href = '/login';
                    }}
                  >
                    成為 Sorra 會員
                  </button>
                </div>
              </div>
            </div>
          </MaxWidthContainer>
        </div>

        <Footer />

        <CommentPopup
          externalPopupShown={isCommentModalShow}
          externalProductID={null}
          externalProductBrandName={null}
          externalProductName={null}
          setExternalPopupShown={setIsCommentModalShow}
        />

        <MobileTabBar props={{ highlighted: 'home' }} />
      </main>
    </div>
  );
}
